import React from 'react';

interface ErrorMessageProps {
  message: string;
  show?: boolean;
  className?: string;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ message, show = true, className = '' }) => {
  if (!show || !message) {
    return null;
  }

  return (
    <div className={`bg-red-50 border border-red-200 rounded-md p-3 ${className}`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <span className="material-icons text-red-400" style={{ fontSize: '20px' }}>
            error
          </span>
        </div>
        <div className="ml-3">
          <p className="text-sm text-red-600">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default ErrorMessage;
